import React from "react";
import PropTypes from "prop-types";
import { StyledIconWrap } from "./styled";

const IconWrap = ({ children, rotate, align, customStyle }) => {
    return (
        <StyledIconWrap transformRotate={rotate} align={align} customStyle={customStyle}>
            {children}
        </StyledIconWrap>
    );
};

IconWrap.propTypes = {
    children: PropTypes.node,
    customStyle: PropTypes.array,
    rotate: PropTypes.number,
    align: PropTypes.oneOf(['left', 'center', 'right'])
};

IconWrap.defaultProps = {
    rotate: 0,
    align: 'left'
};

export default React.memo(IconWrap);
